import { CommonModule, getCurrencySymbol } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule, Routes } from '@angular/router';
import { ErrorMsgComponent } from '@fitness-force/errors';
import { AuthguardService, AngularQueryBuilderComponent, TaskCreateComponent, TenantResolverService } from '@fitness-force/shared';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';

import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';

import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { TableModule } from 'primeng/table';
import { TreeSelectModule } from 'primeng/treeselect';
import { CreateOpportunityComponent } from 'libs/crm/src/lib/create-opportunity/create-opportunity.component';
import { SendBulkEmailComponent, SendBulkSmsComponent, SendWhatsappComponent } from '@fitness-force/campaigns';
import { BehaviorSubject, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { CITY_MASTER_STATE_LIST, COUNTRY_MASTER_STATE, COUNTRY_MASTER_STATE_LIST, STATE_MASTER_STATE_LIST, TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { ActionPayload, ActionsGroup, AutomationActionPayload, AutomationActions, AutomationActionsGroup, AutomationTableData, Campaign, CampaignActionsGroup, CampaignById, CampaignRequest, City, Country, EmailActionPayload, NotificationToStaff, Params, Rule, ScheduleActionPayload, SmsActionPayload, SourceDataExtractionRules, State, TENANTSINTERFACE, TENANT_MODEL, TaskActionPayload, WhatsappActionPayload } from '@fitness-force/models';
import { AutomationEventType, CampaignExecutionType, CampaignSource, EmailSendType, OwnershipLevel, SMSSendType, SendNotificationTo, TaskCreateType, WhatsAppSendType } from '@fitness-force/enum';
import { CampaignService } from 'libs/api/src/lib/campaign/campaign.service';
import { CommonService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { TreeNode } from 'primeng/api';
import { DomSanitizer } from '@angular/platform-browser';
import { BreadcrumbComponent} from '@fitness-force/common/breadcrumb';
import { CONSTANTS_PREBUILD_CAMPAIGNS } from 'libs/constants/src/lib/constant.prebuild_campaigns';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'create-campaign',
  templateUrl: './create-campaign.component.html',
  styleUrls: ['./create-campaign.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ToggleSwitchModule,
    InputTextModule,
    DatePickerModule,
    SelectModule,
    EditorModule,
    ButtonModule,
    FileUploadModule,
    ErrorMsgComponent,
    OverlayModule,
    PopoverModule,
    CheckboxModule,
    TableModule,
    TreeSelectModule,
    CreateOpportunityComponent,
    SendBulkEmailComponent,
    SendBulkSmsComponent,
    SendWhatsappComponent,
    TaskCreateComponent,
    ErrorMsgComponent,
    AngularQueryBuilderComponent,
    BreadcrumbComponent,
    InputNumberModule,
    TranslateModule,
    RouterModule
  ]
})
export class CreateCampaignComponent implements OnInit {
  showActionGroup1: boolean = true;
  showTable: boolean = true;
  actionsTableData:AutomationTableData[] = [];
  tenants: any[] = [];
  selectedTenant: { name: string } | undefined;
  tenantAccess: TENANT_MODEL[] = [];
  state$: State[] = [];
  city$: City[] = [];
  country$: Country[] = [];
  createCampaignForm: UntypedFormGroup = new UntypedFormGroup({});
  amountSpenderForm: UntypedFormGroup = new UntypedFormGroup({});
  Actions = [
    { text: 'SEND_EMAIL', key: 'sendemail' }, { text: 'SEND_SMS', key: 'sendsms' }, { text: 'SEND_WHATSAPP', key: 'sendwhatsapp'}, { text: 'CREATE_TASK', key: 'createtask' },
    //{ text: 'CREATE_OPPORTUNITY', key: 'createopportunity'}
  ];
  values: string[] = ['Mr.', 'Mrs.'];
  showCreateOpportunityPopup: boolean = false;
  showTaskCreate: boolean = false;
  showBulkEmailPopup: boolean = false;
  showBulkSmsPopup: boolean = false;
  showBulkWhatsAppPopup: boolean = false;
  EmailSendType: EmailSendType = EmailSendType.Campaign;
  SMSSendType: SMSSendType = SMSSendType.Campaign;
  WhatsAppSendType: WhatsAppSendType = WhatsAppSendType.Campaign;
  taskCreateType: TaskCreateType = TaskCreateType.Campaign;
  campaignSource: CampaignSource = CampaignSource.Rules;
  getAccessTenantList$: Observable<any> = new Observable();
  tenantId = 0;
  btnLoading: boolean = false;
  emailActionPayload: EmailActionPayload | undefined; //= new BehaviorSubject<EmailActionPayload>({} as EmailActionPayload); 
  smsActionPayload: SmsActionPayload | undefined; // new BehaviorSubject<SmsActionPayload | null>({} as SmsActionPayload); 
  whatsAppActionPayload: WhatsappActionPayload | undefined;// = new BehaviorSubject<WhatsappActionPayload>({} as WhatsappActionPayload); 
  taskActionPayload: TaskActionPayload | undefined;  //= new BehaviorSubject<TaskActionPayload>({} as TaskActionPayload); 
  minDate: Date = new Date();
  maxDate: Date = new Date(new Date().setDate(new Date().getDate() + 30));
  eventType= AutomationEventType[AutomationEventType.Campaign];
  campaignId: number = 0;
  sqlRule = new BehaviorSubject<string>("");
  showAmountSpenderPopup: boolean = false;
  selectedPrebuildCampaign:any;
  convertAmountKeysMapping = ["client_lifetimevalue_1"];
  campaignGroups: any[] = [];
  jsonRule: string = '';
  selectedCampaign: any;
  currencySymbol$ = new BehaviorSubject<string>('');


  constructor(private fb: FormBuilder, private store: Store, private timeService: TimeconversionService,
    private campaignsService: CampaignService,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private toastMessageService: ToastMessageService, 
    private commonService: CommonService,
    private sanitizer: DomSanitizer, 
    private router: Router
   ) {

      if (this.route.snapshot.paramMap.get('id')) {
        this.campaignId = parseInt(this.route.snapshot.paramMap.get('id')!);
      }

    this.actionsTableData = [
      { text: 'SEND_EMAIL', key: 'sendemail', icon: "fa fa-envelope font-light", color: "cyan-500", status: "Not Done", configured: false, action_data:{} as ScheduleActionPayload,action_payload:{} as any,description:"",formgroup:{} as any,notificationTo:SendNotificationTo.Client,schedule_event:"",schedule_in_min:0,uuid:"" }, { text: 'SEND_SMS', key: 'sendsms', icon: "fa fa-comments", color: "pink-500", status: "Not Done", configured: false, action_data:{} as ScheduleActionPayload,action_payload:{} as any,description:"",formgroup:{} as any,notificationTo:SendNotificationTo.Client,schedule_event:"",schedule_in_min:0,uuid:"" }, { text: 'CREATE_TASK', key: 'createtask', icon: "fa fa-phone", color: "orange-500", status: "Not Done", configured: false ,action_data:{} as ScheduleActionPayload,action_payload:{} as any,description:"",formgroup:{} as any,notificationTo:SendNotificationTo.Client,schedule_event:"",schedule_in_min:0,uuid:"" }, { text: 'SEND_WHATSAPP', key: 'sendwhatsapp', icon: "fa fa-whatsapp", color: "green-500", status: "Not Done", configured: false ,action_data:{} as ScheduleActionPayload,action_payload:{} as any,description:"",formgroup:{} as any,notificationTo:SendNotificationTo.Client,schedule_event:"",schedule_in_min:0,uuid:"" }
    ];


    this.createCampaignForm = this.fb.group({
      campaign_name: ['', [Validators.required]],
      campaign_action_date: [new Date(), Validators.required],
      campaign_description: ['', [Validators.required]],
      selected_tenant: ['', [Validators.required]],
      rule: ['', [Validators.required]],
    });

    this.amountSpenderForm = this.fb.group({
      amount: ['', [Validators.required]]
    });

    this.Actions.forEach((action) => {
      this.createCampaignForm.addControl(
        'selectedAction_' + action.key,
        new UntypedFormControl(false)
      );
    });

  }

  ngOnInit(): void {
    //this.minDate = this.calculateTomorrowDate();
    this.minDate = new Date();
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      this.SelectedTenantsFormControl.setValue([this.tenantId]);
      this.tenantAccess = tenant.accessed_tenant;
      this.getTreeViewData()
    });

    this.store.select(COUNTRY_MASTER_STATE).subscribe((country) => {
      this.currencySymbol$.next(getCurrencySymbol(
        country.currency_code,
        'narrow',
        'en-US'
      ));
    });

    if (this.campaignId && this.campaignId > 0) {
      this.getCampaignData();
    }

    // Initialize campaign groups
    this.initializeCampaignGroups();
  }

  // Add new method to initialize campaign groups
  initializeCampaignGroups() {
    // Group campaigns by category
    const groupedCampaigns = CONSTANTS_PREBUILD_CAMPAIGNS.CAMPAIGNS.reduce((groups: any, campaign: any) => {
      const category = campaign.category;
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push({
        label: campaign.name,
        value: campaign.key,
        description: campaign.description,
        sql_rule: campaign.sql_rule,
        category: category  // Add category to each item for searching
      });
      return groups;
    } ,{});

    // Convert to PrimeNG dropdown format
    this.campaignGroups = Object.keys(groupedCampaigns).map(category => ({
      label: category,
      value: category.toLowerCase().replace(/\s+/g, '_'),
      items: groupedCampaigns[category]
    }));

    this.cd.detectChanges();
  }

  // Update campaign selection handler
  onCampaignSelect(event: any) {
    if (event.value) {
      // Find the selected campaign from the constants
      const selectedCampaign = CONSTANTS_PREBUILD_CAMPAIGNS.CAMPAIGNS.find(
        (campaign: any) => campaign.key === event.value
      );

      this.selectedPrebuildCampaign = selectedCampaign;

      if (selectedCampaign) {
        if (selectedCampaign.sql_rule) {
          let ruleObj = JSON.parse(selectedCampaign.sql_rule);
          const sqlQuery = ruleObj.sql;
          let params = ruleObj.params;

          // Special handling for BIRTHDAY_MONTH campaign
          if (selectedCampaign.key === 'BIRTHDAY_MONTH') {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth(); // 0-11

            // Create start date (1st of current month)
            const startDate = new Date(year, month, 1);
            
            // Create end date (last day of current month)
            const endDate = new Date(year, month + 1, 0);

            // Format dates as YYYY-MM-DD
            const formatDate = (date: Date) => {
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}`;
            };

            // Update the params with dynamic dates
            params = {
              ...params,
              client_dob_1: formatDate(startDate),
              client_dob_2: formatDate(endDate)
            };
          }

          if (selectedCampaign.key === 'HIGH_SPENDERS') {
            this.showAmountSpenderPopup = true;
            return;
          }

          // Create the JSON rule string
          this.jsonRule = JSON.stringify({
            sql: sqlQuery,
            params: params
          });

          const actualSqlQuery = sqlQuery.replace(/:(\w+)/g, (match: any, paramName: any) => {
            if (params[paramName] !== undefined) {
              // If the parameter value is a date string, format it properly
              const value = params[paramName];
              if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                return `'${value}'`; // Wrap date strings in quotes
              }
              return params[paramName];
            }
            return match; // Return the placeholder unchanged if param not found
          });

          this.sqlRule.next(actualSqlQuery);
          this.RuleFormControl.setValue(this.jsonRule);
        }

        // Update campaign name and description if they're empty
        if (!this.CampaignNameFormControl.value) {
          this.CampaignNameFormControl.setValue(selectedCampaign.name);
        }
        if (!this.CampaignDescriptionFormControl.value) {
          this.CampaignDescriptionFormControl.setValue(selectedCampaign.description);
        }

        this.cd.detectChanges();
      }
    }
  }

  clearCampaign() {
    this.CampaignNameFormControl.setValue('');
    this.CampaignDescriptionFormControl.setValue('');
    this.RuleFormControl.setValue('');
    this.sqlRule.next('');
    this.jsonRule = '';
    this.cd.detectChanges();
  }

  getCampaignData() {
    this.campaignsService.GetCampaignById( this.tenantId, this.campaignId).subscribe((campaign) => {
      this.patchFormData(campaign);
    });
  }

  patchFormData(campaign: CampaignById) {
    this.createCampaignForm.patchValue({
      campaign_name: campaign.campaign_name,
      campaign_description: campaign.campaign_description,
      selected_tenant: [this.tenantId],
    });
    this.configureExistingActions(campaign);
  }

  configureExistingActions(campaign: CampaignById) {
    if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].source_data_extraction_rules)))
      {
        let ruleObj = JSON.parse(campaign.camp_actions[0].source_data_extraction_rules);
        var sqlQuery = ruleObj.rule.sql;
        const params = ruleObj.rule.params;
        const actualSqlQuery = sqlQuery.replace(/:(\w+)/g, (match:any, paramName:any) => {
            if (params[paramName] !== undefined) {
                return params[paramName];
            }
            return match; // Return the placeholder unchanged if param not found
        });
        this.sqlRule.next(actualSqlQuery);
        this.RuleFormControl.setValue(actualSqlQuery);
      }
      if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].email_action_payload)))
        {
          this.actionsTableData.forEach(o => {
            if (o.key == 'sendemail') {
              o.status = "Done";
              o.configured = true;
              o.action_payload= JSON.parse(campaign.camp_actions[0].email_action_payload);
              o.schedule_in_min=  0
            }
          });
          this.emailActionPayload = JSON.parse(campaign.camp_actions[0].email_action_payload);
          this.createCampaignForm.get('selectedAction_sendemail')?.setValue(true);
        }
        if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].sms_action_payload)))
        {
          this.actionsTableData.forEach(o => {
            if (o.key == 'sendsms') {
              o.status = "Done";
              o.configured = true;
              o.action_payload= JSON.parse(campaign.camp_actions[0].sms_action_payload);
              o.schedule_in_min=  0
            }
          });
          this.smsActionPayload = JSON.parse(campaign.camp_actions[0].sms_action_payload);
          this.createCampaignForm.get('selectedAction_sendsms')?.setValue(true);
        }
        if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].whatsapp_action_payload)))
        {
          this.actionsTableData.forEach(o => {
            if (o.key == 'sendwhatsapp') {
              o.status = "Done";
              o.configured = true;
              o.action_payload= JSON.parse(campaign.camp_actions[0].whatsapp_action_payload);
              o.schedule_in_min=  0
            }
          });
          this.whatsAppActionPayload = JSON.parse(campaign.camp_actions[0].whatsapp_action_payload);
          this.createCampaignForm.get('selectedAction_sendwhatsapp')?.setValue(true);
        }
        if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].task_action_payload)))
        {
          this.actionsTableData.forEach(o => {
            if (o.key == 'createtask') {
              o.status = "Done";
              o.configured = true;
              o.action_payload= JSON.parse(campaign.camp_actions[0].task_action_payload);
              o.schedule_in_min=  0
            }
          });
          this.taskActionPayload = JSON.parse(campaign.camp_actions[0].task_action_payload);
          this.createCampaignForm.get('selectedAction_createtask')?.setValue(true);
        }
     
        this.cd.detectChanges();
  }

  checkObjectEmpty(obj: any): boolean {
    for (let i in obj) return false;
    return true;
  }

  GetCountry(): void {
    this.store.select(COUNTRY_MASTER_STATE_LIST).subscribe((country) => {
      this.country$ = country;
    })
  }

  GetState(): void {
    this.store.select(STATE_MASTER_STATE_LIST).subscribe((state) => {
      this.state$ = state;
    })
  }

  GetCity(): void {
    this.store.select(CITY_MASTER_STATE_LIST).subscribe(city => {
      this.city$ = city;
    });
  }

  calculateTomorrowDate() {
    const today = new Date().setHours(0, 0, 0, 0);
    let tomorrowDate = new Date(today);
    return new Date(tomorrowDate.setDate(tomorrowDate.getDate() + 1));
  }

  // getStatesForCountryCodes(selectedCountryCodes: string[]): string[] {
  //   const filteredStates = this.state$
  //     .filter((state) => selectedCountryCodes.includes(state.country_code))
  //     .map((state) => state.code);

  //   return Array.from(new Set(filteredStates));
  // }

  getTreeViewData() {
    const allCountryCodes = this.tenantAccess.map((tenant) => tenant.country);
    const alltenantStateCodes = this.tenantAccess.map((tenant) => tenant.state);
    const distinctCountryCodes = allCountryCodes.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    const distinctStateCodes = alltenantStateCodes.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

    const treeViewData = [];
    let i = 0;
    for (const state of distinctStateCodes) {
      const citiesInState = Array.from(new Set(
        this.tenantAccess
          .filter((tenant) => tenant.state === state)
          .map((tenant) => tenant.city)
      ));

      const stateNode = {
        key: i,
        label: state,
        icon: 'fa fa-globe',
        children: new Array
      };
      let j = 0;
      for (const city of citiesInState) {
        const tenantsInCity = this.tenantAccess
          .filter((tenant) => tenant.state === state && tenant.city === city)
          .map((tenant) => ({
            label: tenant.name_primary_language,
            tenantid: tenant.id,
            selectable:tenant.status.toLowerCase() === 'inactive' ? false : true,
            styleClass: tenant.status.toLowerCase() === 'inactive' ? 'p-disabled' : '',
            children: []
          }));

        stateNode.children.push({
          key: j,
          label: city,
          icon: 'fa fa-globe',
          children: tenantsInCity
        });
        j++;
      }

      treeViewData.push(stateNode);
      i++;
    }
    this.tenants = treeViewData;
  }


  ToggleActions(event: any, action: string) {
    this.actionsTableData.forEach(o => {
      if (o.key == action) o.configured = event.checked;
    });
  }

  configureActions(action: string) {
    switch (action) {
      case "sendemail":
        {
          this.showBulkEmailPopup = true;
        }
        break;
      case "sendsms":
        {
          this.showBulkSmsPopup = true;
        }
        break;
      case "sendwhatsapp":
        {
          this.showBulkWhatsAppPopup = true;
        }
        break;
      case "createtask":
        {
          this.taskCreateType = TaskCreateType.Campaign;
          this.showTaskCreate = true;
        }
        break;
      case "createopportunity":
        {
          this.showCreateOpportunityPopup = true;
        }
        break;
    }
  }

  removeAction(action: string) {
    this.actionsTableData = this.actionsTableData.filter(o => o.key != action);
    this.actionsTableData.forEach(o => {
      if (o.key == action) o.configured = false;
    });
    this.createCampaignForm.get('selectedAction_' + action)?.setValue(false);
  }


  CreateCampaign() {
    if (this.createCampaignForm.valid) {
      if (!this.isActionSelected()) {
        this.translateService.get('CAMPAIGN.WARNING_MSG')
          .subscribe((translation) => {
            this.toastMessageService.showWarning(translation);
          });
        this.cd.detectChanges();
        return;
      }
      this.btnLoading = true;
      let selectedTenants = [this.tenantId] //this.SelectedTenantsFormControl.value as TreeNode[];
      let payloadRequest: CampaignRequest[] = [] as CampaignRequest[];
      const formValues = this.createCampaignForm.value;
     // let data = this.filterLastChildren(selectedTenants);

     selectedTenants.forEach((tenantId: any) => {
        let payload: CampaignRequest = {} as CampaignRequest;
        payload.tenant_id = tenantId;
        payload.campaign_name = formValues["campaign_name"];
        payload.campaign_isvisble = true;
        payload.campaign_description = formValues["campaign_description"];
        payload.actions_group = {} as CampaignActionsGroup;
        let actionGroups: CampaignActionsGroup = {} as CampaignActionsGroup;
        actionGroups.campaign_action_date = this.timeService.ConvertLocalDateTimeToUTC(formValues["campaign_action_date"]);
        actionGroups.source_data_type = CampaignSource.Rules;
        let sourceDataExtractionRules: SourceDataExtractionRules = {} as SourceDataExtractionRules;
        let rule: Rule = {} as Rule;
        let params: Params = {} as Params;
        rule.params = params;
        let jsonString: string = formValues["rule"];
        if(jsonString && jsonString!= "")
        {
          const jsonObject = JSON.parse(jsonString);
          rule.params = this.convertAmountKeys(jsonObject.params);
          rule.sql = jsonObject.sql;
        }
        sourceDataExtractionRules.clients = null;
        sourceDataExtractionRules.reports = null;
        sourceDataExtractionRules.rule = Object.keys(rule.params).length > 0 ? rule : null;
        sourceDataExtractionRules.jsonrule = Object.keys(rule.params).length > 0 ? rule : null;
        actionGroups.source_data_extraction_rules = sourceDataExtractionRules;
        actionGroups.action_payload =  [] as AutomationActionPayload[];
        let actionPayloads: AutomationActionPayload = {} as AutomationActionPayload;
        actionPayloads.actions = {} as AutomationActions;
        this.Actions.forEach(action => {
          actionPayloads.actions['webhook_action_payload'] = null;
          if (action.key == 'sendemail') {
            if (formValues["selectedAction_" + action.key]) {
              actionPayloads.actions['client_email_action_payload'] = this.emailActionPayload ? this.emailActionPayload : null;
            }
            else {
              actionPayloads.actions['client_email_action_payload'] = null;
            }
          }
          if (action.key == 'sendsms') {
            if (formValues["selectedAction_" + action.key]) {
              actionPayloads.actions['client_sms_action_payload'] = this.smsActionPayload ? this.smsActionPayload : null;
            }
            else {
              actionPayloads.actions['client_sms_action_payload'] = null;
            }
          }
          if (action.key == 'sendwhatsapp') {
            if (formValues["selectedAction_" + action.key]) {
              actionPayloads.actions['client_whatsapp_action_payload'] = this.whatsAppActionPayload ? this.whatsAppActionPayload : null;
            }
            else {
              actionPayloads.actions['client_whatsapp_action_payload']
            }
          }
          if (action.key == 'createtask') {
            if (formValues["selectedAction_" + action.key]) {
              actionPayloads.actions['staff_task_action_payload'] = this.taskActionPayload ? this.taskActionPayload : null;
              let notificationStaff:NotificationToStaff = {} as NotificationToStaff;
              notificationStaff.notify_record_associated_staff = true;
              notificationStaff.notify_additional_staff_to =[];
              actionPayloads.actions['notification_staff'] = notificationStaff;
            }
            else {
              actionPayloads.actions['staff_task_action_payload'] = null;
              let notificationStaff:NotificationToStaff = {} as NotificationToStaff;
              notificationStaff.notify_record_associated_staff = false;
              notificationStaff.notify_additional_staff_to =[];
              actionPayloads.actions['notification_staff'] = notificationStaff;
            }
          }
          actionPayloads.schedule_in_min = 0;
        }
        );
        
        actionGroups.action_payload.push(actionPayloads);
        payload.actions_group = actionGroups;
        payload.campaign_ownership = OwnershipLevel.Tenant;
        payload.campaign_franchise = 0;
        payloadRequest.push(payload);

      });
      this.campaignsService.CreateCampaigns(payloadRequest).subscribe({
        next: (res) => {
          this.translateService.get('CAMPAIGN.MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.btnLoading = false;
          this.createCampaignForm.reset();
          this.cd.detectChanges();
          this.router.navigateByUrl('/campaign');
        },
        error: (error) => {
          this.toastMessageService.showError(error);
          this.btnLoading = false;
          this.cd.detectChanges();
        },
      });
    }
    else {
      Object.keys(this.createCampaignForm.controls).forEach((field) => {
        const control = this.createCampaignForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      const firstElementWithError: Element | null = document.querySelector('.ng-invalid');
      if (firstElementWithError) firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      this.btnLoading = false;
      this.cd.detectChanges();
    }
  }

  convertAmountKeys(params: any) {
    // Helper function to calculate similarity between two strings
    const calculateSimilarity = (str1: string, str2: string): number => {
      const longer = str1.length > str2.length ? str1 : str2;
      const shorter = str1.length > str2.length ? str2 : str1;
      
      if (longer.length === 0) {
        return 1.0;
      }

      // Convert both strings to lowercase for better matching
      const s1 = longer.toLowerCase();
      const s2 = shorter.toLowerCase();
      
      // Calculate the Levenshtein distance
      const costs: number[] = [];
      for (let i = 0; i <= s1.length; i++) {
        let lastValue = i;
        for (let j = 0; j <= s2.length; j++) {
          if (i === 0) {
            costs[j] = j;
          } else if (j > 0) {
            let newValue = costs[j - 1];
            if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
              newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
            }
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
        if (i > 0) {
          costs[s2.length] = lastValue;
        }
      }
      
      // Calculate similarity as a ratio
      return (longer.length - costs[shorter.length]) / longer.length;
    };

    Object.keys(params).forEach((paramKey: string) => {
      // Check each key in convertAmountKeysMapping for similarity
      this.convertAmountKeysMapping.forEach((mappingKey: string) => {
        const similarity = calculateSimilarity(paramKey, mappingKey);
        
        // If similarity is greater than 80%
        if (similarity > 0.8 && params[paramKey]) {
          // Convert the amount
          params[paramKey] = this.commonService.ConvertMinorCurrencyFromAmount(params[paramKey]);
        }
      });
    });
    
    return params;
  }

  filterLastChildren(treeData: TreeNode[]): TreeNode[] {
    const lastChildren: TreeNode[] = [];

    function traverse(node: TreeNode) {
      if (node.children && node.children.length > 0) {
        // node.children.forEach((child) => {
        //   traverse(child);
        // });
      } else {
        lastChildren.push(node);
      }
    }

    treeData.forEach((node) => {
      traverse(node);
    });
    return lastChildren;
  }

  hideOpportunity(e: any) {
    this.showCreateOpportunityPopup = false;
  }

  HideTaskCreate(e: any) {
    this.showTaskCreate = false;
  }

  HideSendEmail(event: any) {
    this.showBulkEmailPopup = false;
    this.emailActionPayload = event.data;
    if (event.data) {
      this.actionsTableData.forEach(o => {
        if (o.key == 'sendemail') {
          o.status = "Done";
          o.configured = true;
          o.action_payload= event.data;
          o.schedule_in_min=  0
        }
      });
    }
  }

  HideSMSEmail(event: any) {
    this.showBulkSmsPopup = false;
    this.smsActionPayload = event.data;
    if (event.data) {
      this.actionsTableData.forEach(o => {
        if (o.key == 'sendsms') {
          o.status = "Done";
          o.configured = true;
          o.action_payload= event.data;
          o.schedule_in_min=  0
        }
      });
    }
  }

  HideWhatsAppPopup(event: any) {
    this.showBulkWhatsAppPopup = false;
    this.whatsAppActionPayload = event.data;
    if (event.data) {
      this.actionsTableData.forEach(o => {
        if (o.key == 'sendwhatsapp') {
          o.status = "Done";
          o.configured = true;
          o.action_payload= event.data;
          o.schedule_in_min=  0
        }
      });
    }
  }

  hideTaskCreate(event: any) {
    this.showTaskCreate = false;
    this.taskActionPayload = event.data;
    if (event.data) {
      this.actionsTableData.forEach(o => {
        if (o.key == 'createtask') {
          o.status = "Done";
          o.configured = true;
          o.action_payload= event.data;
          o.schedule_in_min=  0
        }
      });
    }
  }

  CancelCampaign() {
    this.createCampaignForm.reset();
    this.router.navigateByUrl('/campaign');
  }

  isActionSelected() {
    return this.actionsTableData.filter(o => o.configured && o.status == 'Done').length > 0;
  }

  getRule(event:any)
  {
    console.log(event);
    this.RuleFormControl.setValue(event.rule);
  }

  closeDialogEvent() {
    this.showAmountSpenderPopup = false;
    this.clearCampaign();
    this.cd.detectChanges();
  }

  addAmountSpender() {
    if(this.amountSpenderForm.valid)
    {
    let ruleObj = JSON.parse(this.selectedPrebuildCampaign.sql_rule);
    const sqlQuery = ruleObj.sql;
    const params = ruleObj.params;  

    params['client_lifetimevalue_1'] = this.AmountSpenderFormControl.value;
    const actualSqlQuery = sqlQuery.replace(/:(\w+)/g, (match:any, paramName:any) => {
      if (params[paramName] !== undefined) {
        return params[paramName];
      }
    });
    this.sqlRule.next(actualSqlQuery);
    this.RuleFormControl.setValue(actualSqlQuery);
    // Update campaign name and description if they're empty
    if (!this.CampaignNameFormControl.value) {
      this.CampaignNameFormControl.setValue(this.selectedPrebuildCampaign.name);
    }
    if (!this.CampaignDescriptionFormControl.value) {
      this.CampaignDescriptionFormControl.setValue(this.selectedPrebuildCampaign.description);
    }
    this.amountSpenderForm.reset();
    this.showAmountSpenderPopup = false;
    this.cd.detectChanges();
    }
    else
    {
      this.amountSpenderForm.markAllAsTouched();
      this.cd.detectChanges();
    }
  }

  get getEmailActipnPayload() {
    return new BehaviorSubject<EmailActionPayload>(this.emailActionPayload!)
  }

  get getSmsActipnPayload() {
    return new BehaviorSubject<SmsActionPayload>(this.smsActionPayload!)
  }

  get getWhatsappActipnPayload() {
    return new BehaviorSubject<WhatsappActionPayload>(this.whatsAppActionPayload!)
  }

  get getTaskActipnPayload() {
    return new BehaviorSubject<TaskActionPayload>(this.taskActionPayload!)
  }

  get ActionTableData() {
    return this.actionsTableData.filter(o => o.configured);
  }

  get CampaignNameFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['campaign_name'] as UntypedFormControl;
  }

  get CampaignDescriptionFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['campaign_description'] as UntypedFormControl;
  }

  get CampaignActionDateFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['campaign_action_date'] as UntypedFormControl;
  }

  get SelectedActionsFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['selected_actions'] as UntypedFormControl;
  }

  get SelectedTenantsFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['selected_tenant'] as UntypedFormControl;
  }

  get RuleFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['rule'] as UntypedFormControl;
  }

  get AmountSpenderFormControl(): UntypedFormControl {
    return this.amountSpenderForm.controls['amount'] as UntypedFormControl;
  }

}

